import React from 'react'

import { Row } from 'antd'

import CustomInput from '../../../components/CustomInput/customInput'

const SumCultivars = ({ organizationId, cultivars = {} }) => {
  const organization = organizationId == '11' ? ' - Monsoy' : ' - Intacta'
  const fields = ['totalArea', 'checkArea', 'i2xArea', 'organizationArea', 'organizationOpportunity', 'i2xOpportunity']

  function renderInputs() {
    return fields.map((field) => (
      <CustomInput
        field={field}
        key={field}
        errors={{}}
        setFieldValue={() => ({})}
        rowSpan={6}
        value={cultivars}
        suffixLabel={field.includes('organization') ? organization : ''}
        handleBlur={() => ({})}
        disabled
      />
    ))
  }

  return <Row type="flex">{renderInputs()}</Row>
}

export default SumCultivars
